module.exports = __webpack_public_path__ + "media/slot-game/icecream-d176514c.svg";